// https://vuex.vuejs.org/en/state.html

export default {
  //
  token: localStorage.getItem('access_token') || null,
  tokenExpires: localStorage.getItem('token_expires') || null,
  refreshToken: localStorage.getItem('refresh_token') || null,
  result: null
}
